import { useSessionStorage } from "@uidotdev/usehooks";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import { IFilterRunsheet } from "../../types/interface";
import { hasValues } from "../../utils/hasValues";
import Card from "../Reusable/Card";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import RunsheetFilter from "./RunsheetFilter";
import { tw } from "@careinfo/tailwind";

const RunsheetList = () => {
  const navigate = useNavigate();
  const [localState, handleSetState] = useSessionStorage<IFilterRunsheet>(
    "runsheet-filter",
    {
      created__range: null,
      vehicle: null,
      driver: null,
    }
  );
  const [isFilterVisible, setFilterVisiable] = useState(hasValues(localState));
  const { setValue, getValues, watch, reset, control } =
    useForm<IFilterRunsheet>({
      defaultValues: async () => ({
        created__range: localState?.created__range ?? null,
        vehicle: localState?.vehicle ?? null,
        driver: localState?.driver ?? null,
      }),
    });

  const handleFilterReset = () => {
    reset({
      created__range: null,
      vehicle: null,
      driver: null,
    });
  };

  const defaultColumns: any = [
    {
      header: "Runsheet ID",
      accessorKey: "tracking_number",
      cell: NACell,
    },
    {
      header: "Created",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },
    {
      header: "Updated",
      accessorKey: "modified",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },
    {
      header: "Vehicle",
      accessorKey: "vehicle.license_number",
      cell: NACell,
    },
    {
      header: "Driver",
      accessorKey: "driver.user.full_name",
      cell: NACell,
    },

    {
      header: "Total Items",
      accessorKey: "items.total",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Delivered Items",
      accessorKey: "delivered_count",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Destination",
      accessorKey: "destination_branch.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`whitespace-nowrap`}>{getValue()}</p>
          </>
        );
      },
    },
  ];
  const handleEditNavigate = (row: any) => {
    navigate(`edit/${row?.original?.id}`);
  };
  const filterParams = watch();

  useEffect(() => {
    handleSetState({
      ...localState,
      ...filterParams,
    });
  }, [filterParams]); //eslint-disable-line

  const params = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(",");
        } else if (typeof value === "object") {
          newValue[key] = value.id;
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);

  return (
    <>
      <Card title="Filters" onClick={() => setFilterVisiable(!isFilterVisible)}>
        <RunsheetFilter
          isFilterVisible={isFilterVisible}
          setValue={setValue}
          getValues={getValues}
          handleFilterReset={handleFilterReset}
          control={control}
        />
      </Card>
      <DataTable
        url={`${APIS.RUNSHEET}`}
        queryKey={"runsheet"}
        params={{
          ...params(),
          type: "runsheet",
        }}
        handleEditNavigate={handleEditNavigate}
        columns={defaultColumns}
        orderSearch={true}
        addNewPagePath={"/create"}
        tableName={"runsheet"}
      />
    </>
  );
};

export default RunsheetList;
